<template>
  <card title="Lista de Denúncias">
    <template slot="content">
      <div>
        <div class="row">
          <div class="col-md-12">
            <h3>Denúncias</h3>
            <p>Clique no botão editar para visualizar/responder a denúncia.</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <datatable-panel
              :per-page="15"
              :url="`${$root.url}/denuncias?Key=${$root.chaveFront}`"
              :fields="dados"
              no-data-template="Nenhum registro encontrado."
              ref="datatable"
              :search-bar="searchBar"
              >
            </datatable-panel>
          </div>
        </div>
      </div>
    </template>
  </card>
</template>

<script>
import Vue from 'vue'

import VueVirtualTable from 'vue-virtual-table'
import DatatablePanel from 'metawesome-datatable'
import CustomActions from './CustomActions'
import Card from './templates/Card.vue'
import Utils from '@/mixins/utils.js'
import SearchBar from './SearchBar'

Vue.component("custom-actions", CustomActions);

export default {
  name: "ListaDenuncias",
  components: {
    VueVirtualTable,
    DatatablePanel,
    Card,
  },

  mixins: [
    Utils,
  ],

  data() {
    return {
      searchBar: SearchBar,
      dados: [
        {
          name: "protocolo",
          sortField: "protocolo",
          title: "Protocolo",
        },
        {
          name: "criado_por",
          sortField: "criado_por",
          title: "Criado por",
          callback: nome => {
            return this.retornaCriadoPor(nome);
          },
        },
        {
          name: "relacao",
          sortField: "relacao",
          title: "Relação",
          callback: relacao => {
            return this.retornaRelacao(relacao);
          },
        },
        {
          name: "status",
          sortField: "status",
          title: "Status",
          callback: status => {
            return this.retornaStatus(status);
          },
        },
        {
          name: "tipo",
          sortField: "tipo",
          title: "Tipo de Denúncia",
        },
        {
          name: "created_at",
          sortField: "created_at",
          title: "Data de Criação",
          callback: data => {
            return this.retornaData(data);
          },
        },
        {
          name: "__component:custom-actions",
          title: "",
          titleClass: "actions",
        },
      ],
    };
  },

  methods: {
    retornaData(data) {
      const moment = this.$moment(data);

      return moment.format('DD/MM/YYYY - HH:mm');
    },

    retornaStatus(status) {
      if (status == null) {
        return 'Aberto';
      }

      return status;
    },

    retornaCriadoPor(nome) {
      if (nome == null) {
        return 'Anônimo';
      }

      return nome;
    },

    retornaRelacao(relacao) {
      if (relacao == null) {
        return 'Não informado';
      }

      return relacao;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ListaDenuncias.vue